import React from 'react';

import { Badge } from '../ui-kit';
import SkillIcon from './SkillIcon';
import colors from '../../utils/colors';
import UserContact from '../general/UserContact';

// only show names if the AR is on required or below required
const showNamesForLevels = new Set(['on_required', 'below_required']);

const AvailabilityRequirementStatus = ({ interval, showNamesWhenOrangeOrRed }) => (
  <div className="d-flex align-items-stretch align-items-center">
    {interval.availability_requirement_level && (
      <Badge
        className="m-1 d-flex align-items-center"
        key={interval.availability_requirement_level.id}
        color={interval.availability_requirement_level.html_color}
      >
        {interval.availability_requirement_level.short_code}
      </Badge>
    )}
    {interval.skill_statuses.map((status, index) => (
      <Badge className="m-1 d-flex align-items-center gap-1" key={index} color={colors[status.level]}>
        <SkillIcon skill={status.skill} /> {status.assigned_count}
        {showNamesWhenOrangeOrRed &&
          showNamesForLevels.has(status.level) &&
          status.available_memberships.map(m => <UserContact className="ms-1" key={m.id} userId={m.user_id} />)}
      </Badge>
    ))}
  </div>
);

export default AvailabilityRequirementStatus;
